import styles from './Burger.module.scss';
import cn from 'classnames';

export default function Burger({ isOpen, onClick }) {
  return (
    <button className={styles.wrapper} onClick={onClick}>
      <div className={cn(styles.lineTop, isOpen && styles.lineTopTransform)} />
      <div className={cn(styles.lineCenter, isOpen && styles.lineCenterTransform)} />
      <div className={cn(styles.lineBottom, isOpen && styles.lineBottomTransform)} />
    </button>
  );
}
